(function () {
  function openRebuyCart(event) {
    if (!window.Rebuy || !window.Rebuy.SmartCart) return;
    if (event) event.preventDefault();
    window.Rebuy.SmartCart.show();
  }

  function attachCartIconHandler() {
    var cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return false;
    cartIcon.addEventListener('click', openRebuyCart);
    return true;
  }

  if (attachCartIconHandler()) return;

  var observer = new MutationObserver(function () {
    if (attachCartIconHandler()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
